import React from 'react';
import { ScrollIntoView } from './ScrollIntoView';
import { Box, ChatMessageSeparator } from 'pcln-design-system';
import { TravelBotChatSingleDialogGeneric } from './TravelBotChatSingleDialogGeneric';
import HandleSetiActions from './components/HandleSetiActions';
import { QuickActions } from './QuickActions';
import { QuickActionsChips } from './QuickActionsChips';
import { BlockingInputComponent } from './BlockingInputComponent';
import TripProtectionMarker from './components/TripProtectionMarker/TripProtectionMarker';
import Trips from './components/Trips/Trips';
import SignOutActions from './components/SignOutActions/SignOutActions';
import { HotelDetailCardsMessage } from './HotelComponent/HotelDetailCard';
import CalendarComponent from './components/CalendarComponent/CalendarComponent';
import { ButtonChipsAction } from './components/ButtonChipsAction/ButtonChipsAction';
import DisplayFeedbackMarkers from './components/DisplayFeedbackMarker/DisplayFeedbackMarker';
import ChatMessageErrorBoundary from './components/ErrorBoundary/ChatMessageErrorBoundary';
export const ChatMessages = ({
  chatMessages,
  isRetrievingAudio,
  markerComponents,
  isLoading,
  debugMode,
  setIsDisablingInputValue,
  setChatMessages,
  submitMessages,
  submitChatMessageInMarkerComponent,
  submitQuickActionMessage,
  isMobile,
  isShowMoreListingCards
}) => {
  const chatmessageCount = chatMessages.length - 1;
  return React.createElement(React.Fragment, null, chatMessages.map((m, i) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const isLastMessge = chatMessages.length - 1 === i;
    const hasOtherMessageHandler = (m, chatMessage) => {
      const mappedChatMessage = chatMessage.map(result => JSON.stringify(result));
      const index = mappedChatMessage.indexOf(JSON.stringify(m));
      return chatMessage.length - 1 > index;
    };
    // hide the last audio message if we're retreiving audio (since another mechanism shows the text for the audio while it's playing)
    // Since marker components can come back as two different messages, we also have to check the second to last message
    if (isRetrievingAudio) {
      const lastIndex = chatMessages.length - 1;
      const secondLastIndex = chatMessages.length - 2;
      // Case 1: Suppress the last message if its role is 'assistant'
      if (((_a = chatMessages[lastIndex]) === null || _a === void 0 ? void 0 : _a.role) === 'assistant' && i === lastIndex) {
        return null;
      }
      // Case 2: Suppress the last message and the message before it if the last message's role is ''
      // and the message before it has a role of 'assistant'. This handles instances where the marker component
      // information comes back in multiple parts (such as for hotel search)
      if (((_b = chatMessages[lastIndex]) === null || _b === void 0 ? void 0 : _b.role) === '' && ((_c = chatMessages[secondLastIndex]) === null || _c === void 0 ? void 0 : _c.role) === 'assistant' && (i === lastIndex || i === secondLastIndex)) {
        return null;
      }
    }
    // Display a predefined Marker Component
    if (markerComponents[m === null || m === void 0 ? void 0 : m.displayComponentName] && typeof markerComponents[m === null || m === void 0 ? void 0 : m.displayComponentName] === 'function') {
      const Marker = React.memo(markerComponents[m.displayComponentName]);
      const markerComponentProps = (m === null || m === void 0 ? void 0 : m.markerComponentProps) || {};
      const markerProps = Object.assign(Object.assign({}, markerComponentProps), {
        message: m,
        isLoading,
        chatMessages,
        setIsDisablingInputValue,
        setChatMessages,
        submitMessages
      });
      return React.createElement(React.Fragment, {
        key: `chat-msg-host-app-marker-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(Marker, Object.assign({}, markerProps))));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'SEPARATOR_COMPONENT') {
      return React.createElement(React.Fragment, {
        key: `chat-msg-content-separator-${i}`
      }, React.createElement(Box, {
        mb: 4
      }, React.createElement(ChatMessageSeparator, null)));
    }
    if (m.role === 'chatContentSeparator') {
      const content = m.content;
      return React.createElement(ScrollIntoView, {
        key: `chat-msg-content-separator-${m.key}-${i}`
      }, React.createElement(Box, {
        mb: 4
      }, React.createElement(ChatMessageSeparator, {
        message: content
      })));
    }
    if ((m === null || m === void 0 ? void 0 : m.role) && (m === null || m === void 0 ? void 0 : m.content)) {
      return React.createElement(ScrollIntoView, {
        key: `chat-msg-generic-message-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(TravelBotChatSingleDialogGeneric, {
        message: m
      })));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'FIRE_SETI') {
      return React.createElement(React.Fragment, {
        key: `chat-msg-seit-action-message-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(HandleSetiActions, {
        setiValues: (_d = m === null || m === void 0 ? void 0 : m.markerComponentProps) === null || _d === void 0 ? void 0 : _d.setiValues
      })));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'QUICK_ACTIONS') {
      return React.createElement(ScrollIntoView, {
        key: `chat-msg-quick-actions-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(QuickActions, {
        quickActions: (_e = m === null || m === void 0 ? void 0 : m.markerComponentProps) === null || _e === void 0 ? void 0 : _e.quickActions,
        hasOtherMessage: hasOtherMessageHandler(m, chatMessages),
        submitQuickActionMessage: submitQuickActionMessage,
        isSeparatorMsg: ((_f = m === null || m === void 0 ? void 0 : m.markerComponentProps) === null || _f === void 0 ? void 0 : _f.isSeparatorMsg) && chatmessageCount === i
      })));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'QUICK_ACTIONS_CHIPS') {
      return React.createElement(ScrollIntoView, {
        key: `chat-msg-quick-chips-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(QuickActionsChips, {
        quickActions: (_g = m === null || m === void 0 ? void 0 : m.markerComponentProps) === null || _g === void 0 ? void 0 : _g.quickActions,
        hasOtherMessage: hasOtherMessageHandler(m, chatMessages),
        submitQuickActionMessage: submitQuickActionMessage,
        isSeparatorMsg: ((_h = m === null || m === void 0 ? void 0 : m.markerComponentProps) === null || _h === void 0 ? void 0 : _h.isSeparatorMsg) && chatmessageCount === i
      })));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'BUTTON_CHIPS_ACTION') {
      return React.createElement(ScrollIntoView, {
        key: `chat-msg-button-chips-actions-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(ButtonChipsAction, {
        submitButtonChipActionMessage: submitQuickActionMessage,
        hasOtherMessage: hasOtherMessageHandler(m, chatMessages),
        buttonChipsActions: (_j = m === null || m === void 0 ? void 0 : m.markerComponentProps) === null || _j === void 0 ? void 0 : _j.quickActions,
        isSeparatorMsg: ((_k = m === null || m === void 0 ? void 0 : m.markerComponentProps) === null || _k === void 0 ? void 0 : _k.isSeparatorMsg) && chatmessageCount === i
      })));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'SESSION_INITIALIZED') {
      return null;
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'HOTEL_CARDS_MARKER') {
      return React.createElement(React.Fragment, {
        key: `chat-msg-hotel-cards-marker-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(HotelDetailCardsMessage, Object.assign({}, m === null || m === void 0 ? void 0 : m.markerComponentProps, {
        date: m.date,
        setChatMessages: setChatMessages,
        isMobile: isMobile,
        isShowMoreListingCards: isShowMoreListingCards,
        // Submit message when user apply filter options
        submitMessages: submitChatMessageInMarkerComponent
      }))));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'DATE_COMPONENT') {
      return React.createElement(React.Fragment, {
        key: `chat-msg-block-input-marker-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(CalendarComponent, {
        markerComponentProps: m === null || m === void 0 ? void 0 : m.markerComponentProps,
        isLastMessage: isLastMessge
      })));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'BLOCK_INPUT_MARKER') {
      return React.createElement(React.Fragment, {
        key: `chat-msg-block-input-marker-${i}`
      }, React.createElement(BlockingInputComponent, {
        setIsDisablingInputValue: setIsDisablingInputValue
      }));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'PROMPT_TRIP_PROTECTION') {
      return React.createElement(React.Fragment, {
        key: `chat-msg-trip-protection-marker-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(TripProtectionMarker, null)));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'DISPLAY_MY_TRIPS') {
      const {
        tripsList: trips,
        hasMoreTrips,
        deepLinkPrompt,
        tripHeaderMsg
      } = (m === null || m === void 0 ? void 0 : m.markerComponentProps) || {};
      return React.createElement(React.Fragment, {
        key: `chat-msg-display-my-trips-marker-${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(Trips, {
        trips: trips,
        deepLinkPrompt: deepLinkPrompt,
        tripHeaderMsg: tripHeaderMsg,
        hasMoreTrips: hasMoreTrips
      })));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'SHOW_SIGNED_OUT_ACTION_BUTTONS') {
      return React.createElement(React.Fragment, {
        key: `chat-msg-signed-out-actions-marker${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(SignOutActions, null)));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'DISPLAY_FEEDBACK_MARKERS') {
      return React.createElement(React.Fragment, {
        key: `chat-msg-display-feedback-marker${i}`
      }, React.createElement(ChatMessageErrorBoundary, null, React.createElement(DisplayFeedbackMarkers, Object.assign({}, m === null || m === void 0 ? void 0 : m.markerComponentProps))));
    }
    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) && debugMode) {
      console.log('Debug Mode', m === null || m === void 0 ? void 0 : m.displayComponentName);
      console.log(JSON.stringify(m, null, 2));
      return React.createElement(ScrollIntoView, {
        key: `chat-msg-marker-${i}`
      }, React.createElement(Box, null, React.createElement(Box, null, "Marker Component Name: ", m === null || m === void 0 ? void 0 : m.displayComponentName), React.createElement(Box, null, "Check dev console for more details of ", m === null || m === void 0 ? void 0 : m.displayComponentName, " component props")));
    }
  }));
};
export const ChatMessagesList = React.memo(ChatMessages, (prevProps, nextProps) => {
  const sameChatMessagesLen = prevProps.chatMessages.length === nextProps.chatMessages.length;
  const sameLastMessage = prevProps.chatMessages[prevProps.chatMessages.length - 1] === nextProps.chatMessages[nextProps.chatMessages.length - 1];
  const samePromptsLen = prevProps.prompts.length === nextProps.prompts.length;
  const sameLastPrompt = prevProps.prompts[prevProps.prompts.length - 1] === nextProps.prompts[nextProps.prompts.length - 1];
  const valueList = ['isLoading', 'isRetrievingAudio'];
  const sameValues = valueList.every(key => prevProps[key] === nextProps[key]);
  return sameChatMessagesLen && sameLastMessage && samePromptsLen && sameLastPrompt && sameValues;
});